import { API_URL } from '../constants';
import { apiFetch } from './client';

export const getHealthCheckStats = async (queryParams: any) => {
    const params = new URLSearchParams();
    if (queryParams.createdAt_min) params.append('createdAt_min', queryParams.createdAt_min);
    if (queryParams.createdAt_max) params.append('createdAt_max', queryParams.createdAt_max);
    const res = await apiFetch(`${API_URL}/mockup/stats/logs?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
}; 

export interface IErrorFormatRow {
    format: string;
    count: number;
}

export interface IErrorFormatsResponse {
    result: IErrorFormatRow[];
    totalCount: number;
}

/**
 * Formats are not a fixed list — whatever the server returns is parsed as-is
 * (string-coerced, lower-cased, counts coerced to numbers, sorted desc).
 */
export const normalizeErrorFormats = (payload: unknown): IErrorFormatsResponse => {
    const obj = (payload && typeof payload === 'object' ? payload : {}) as Record<string, unknown>;
    const raw = Array.isArray(payload) ? payload : Array.isArray(obj.result) ? obj.result : [];
    const result: IErrorFormatRow[] = raw
        .map((row: any) => {
            const format = row?.format ?? row?.name ?? row?.key;
            const count = Number(row?.count ?? row?.value ?? 0);
            return {
                format: format === null || format === undefined || format === '' ? 'unknown' : String(format).toLowerCase(),
                count: Number.isFinite(count) ? count : 0,
            };
        })
        .sort((a, b) => b.count - a.count);
    const total = Number(obj.totalCount);
    return {
        result,
        totalCount: Number.isFinite(total) ? total : result.reduce((s, r) => s + r.count, 0),
    };
};

/** GET /mockup/stats/error-formats — errored uploads grouped by source image format. */
export const getMockupErrorFormats = async (queryParams: { createdAt_min: string; createdAt_max: string }) => {
    const params = new URLSearchParams();
    if (queryParams.createdAt_min) params.append('createdAt_min', queryParams.createdAt_min);
    if (queryParams.createdAt_max) params.append('createdAt_max', queryParams.createdAt_max);
    const res = await apiFetch(`${API_URL}/mockup/stats/error-formats?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return normalizeErrorFormats(await res.json());
};
